import { Helmet } from 'react-helmet-async'
import React from 'react'

type HeadProps = {
  title?: string
  description?: string
  canonical?: string
  prevUrl?: string
  nextUrl?: string
}

export const Head: React.FC<HeadProps> = (props: HeadProps) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1" name="viewport" />
      <meta content="telephone=no" name="format-detection" />
      {/* 基本的にはサーバーサイドでタイトルなどを設定する
          SPA内での移動時のために必要な場合は、ここに渡す形でも設定する */}
      {props.title && <title>{props.title}</title>}
      {props.description && <meta name="description" content={props.description} />}
      {props.canonical && <link rel="canonical" href={props.canonical} />}
      {props.prevUrl && <link rel="prev" href={props.prevUrl} />}
      {props.nextUrl && <link rel="next" href={props.nextUrl} />}
    </Helmet>
  )
}
